<script lang="ts">
  import { onMount } from 'svelte';
  import type { PwNextBackgroundFaderProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  export let entryId: PwNextBackgroundFaderProps['entryId'];
  export let backgroundColor: PwNextBackgroundFaderProps['backgroundColor'];
  export let rootMargin: PwNextBackgroundFaderProps['rootMargin'];
  export let entries: PwNextBackgroundFaderProps['entries'];

  let fader: HTMLDivElement;
  let originalColor: string;
  let observer: IntersectionObserver;

  const onObserve = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && backgroundColor) {
        document.body.style.backgroundColor = backgroundColor;
      } else {
        document.body.style.backgroundColor = originalColor;
      }
    });
  };

  onMount(() => {
    if (backgroundColor) {
      originalColor = getComputedStyle(document.body).backgroundColor;
      observer = new IntersectionObserver(onObserve, { rootMargin, threshold: 0 });
      observer.observe(fader);
    }

    return () => {
      observer?.disconnect();
    };
  });
</script>

<div
  class="PwNextBackgroundFader PwNextBackgroundFader-{entryId}-box-properties"
  data-entry-id={entryId}
  bind:this={fader}
>
  <DynamicChildrenComponent children={entries} />
</div>

<style lang="scss">
  @layer custom-components {
    :global(body) {
      transition: background-color var(--duration-default);
    }
  }
</style>
